import type { ApiClient } from "@/lib/api";
import type {
  CatalogBulkCreateResponse,
  CatalogEntryCreateRequest,
} from "../types";

/**
 * Publish many tools for one subject in a single request. The Coordinator
 * inserts them in one transaction and is idempotent — tools already published to
 * the subject are left as-is rather than erroring — so re-publishing is safe.
 */
export const createCatalogEntries = async (options: {
  client: ApiClient;
  payload: CatalogEntryCreateRequest;
}): Promise<CatalogBulkCreateResponse> => {
  const { client, payload } = options;
  const { data } = await client.post<CatalogBulkCreateResponse>(
    "/catalog",
    payload
  );
  return data;
};
